import React from 'react';

const YogaLogo = ({ size = 24, className = '' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            {/* Lotus flower - clean, renders well at all sizes */}
            {/* Center petal */}
            <path d="M12 4C11 6 11 9 12 11C13 9 13 6 12 4Z" fill="currentColor" opacity="0.95"/>
            {/* Left petal */}
            <path d="M8 6C7 8 8 11 10 12C10 10 9 7 8 6Z" fill="currentColor" opacity="0.85"/>
            {/* Right petal */}
            <path d="M16 6C17 8 16 11 14 12C14 10 15 7 16 6Z" fill="currentColor" opacity="0.85"/>
            {/* Far left petal */}
            <path d="M5 9C5 11 7 13 9 13C8 11 7 9 5 9Z" fill="currentColor" opacity="0.7"/>
            {/* Far right petal */}
            <path d="M19 9C19 11 17 13 15 13C16 11 17 9 19 9Z" fill="currentColor" opacity="0.7"/>
            {/* Lotus base / water line */}
            <path d="M7 15C8.5 13.5 10.5 13 12 13C13.5 13 15.5 13.5 17 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            {/* Stem */}
            <line x1="12" y1="15" x2="12" y2="19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            {/* Left leaf */}
            <path d="M12 18C11 17 9 17 8 18C9 19 11 19 12 18Z" fill="currentColor" opacity="0.7"/>
            {/* Right leaf */}
            <path d="M12 18C13 17 15 17 16 18C15 19 13 19 12 18Z" fill="currentColor" opacity="0.7"/>
        </svg>
    );
};

export default YogaLogo;
